const Icon = () => {

  return (
    <svg width="30" height="32" viewBox="0 0 30 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 27.5L25 16L0 4.50003V0.900024L29.4 14.3V17.7L0 31.1V27.5Z" fill="#D02B48"/>
    </svg>
  );
};
export default Icon;
